import RootStore from 'stores/RootStore'
import { getClientUuid } from 'utils/url'
import { StartupCommand } from './command.interface'

class GetClientDetailsCommand implements StartupCommand {
  name = 'GetClientDetails'
  dependencies = []
  timeout = 10000

  execute = async (rootStore: RootStore) => {
    const tenantUuid = getClientUuid()
    const { fetchClientDetails } = rootStore.clientDetailsStore

    fetchClientDetails(tenantUuid)
  }
}

export default GetClientDetailsCommand
